<template>
  <div class="file-upload is-flex-100" :class="status">
    <div class="columns p-1 is-mobile">
      <div class="column">
        <p class="is-uppercase">{{ title }}</p>
      </div>
      <div v-show="!isUploading" class="column is-narrow">
        <!--div v-show="status === 'waiting'" class="icon is-medium">
          <svg-icon icon="question"/>
        </div-->
        <div v-show="status === 'idle'" class="icon is-medium">
          <svg-icon icon="empty"/>
        </div>
        <div v-show="status === 'success'" class="icon is-medium">
          <svg-icon icon="success"/>
        </div>
        <div v-show="status === 'fail'" class="icon is-medium">
          <svg-icon icon="fail"/>
        </div>
      </div>
    </div>
    <div class="columns p-1">
      <div class="column is-relative">
        <b-upload
          v-model="dropFiles"
          :accept="accept"
          @input="upload"
          capture
          multiple
          drag-drop
          class="is-flex-100">
          <div class="is-cover is-clickable" :style="`background-image:url(${getCover})`" :class="{ 'is-uploading-animation': isUploading }"></div>
        </b-upload>
        <div v-show="isUploading" class="is-upload-progress" :style="uploadPercent?'background: linear-gradient(to right,#00d1b2 '+uploadPercent+'%,transparent '+uploadPercent+'px)':''"/>
      </div>
    </div>
    <div class="columns is-flex-self-end p-1 is-mobile is-picker-foot">
      <div class="column">
        <span class="is-size-7" v-if="uploads[type]"></span>
      </div>
      <div class="column is-actions is-narrow">
        <div class="columns is-flex-self-end p-2 is-mobile">
          <div v-show="modes.includes('capture')" class="column is-hidden-desktop">
            <b-upload
              v-model="dropFiles"
              :accept="accept"
              @input="upload"
              capture
              multiple>
              <span class="icon is-medium is-clickable">
                <svg-icon icon="camera"/>
              </span>
            </b-upload>
          </div>
          <div v-show="modes.includes('upload')" class="column">
            <b-upload
              v-model="dropFiles"
              :accept="accept"
              @input="upload"
              multiple>
              <span class="icon is-medium is-clickable">
                <svg-icon icon="cloud"/>
              </span>
            </b-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'FilePickerMultiple',
  components: {
    SvgIcon
  },
  props: {
    type: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: 'image/*'
      // default: 'image/*,video/*;capture=camera'
    },
    modes: {
      type: Array,
      default: () => ['upload', 'capture']
    },
    title: {
      type: String,
      default: 'title'
    },
    created: {
      type: String,
      default: null
    },
    cover: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      file: null,
      dropFiles: [],
      status: 'idle',
      preview: null,
      uploadPercent: 0
    }
  },
  computed: {
    isUploading () {
      return this.uploadPercent && this.uploadPercent < 100
    },
    getUploaded () {
      if (this.uploads && this.uploads[this.type]) {
        return this.uploads[this.type].path
      }
      return false
    },
    getPreview () {
      return this.preview || this.getUploaded || this.getCover
    },
    getCover () {
      return this.cover || `/img/placeholder/${this.type}.png`
    },
    ...mapState([
      'mycase',
      'uploads'
    ])
  },
  methods: {
    deleteDropFile (index) {
      this.dropFiles.splice(index, 1)
    },
    upload (file) {
      let formData = new FormData()
      formData.append('client_id', 1)
      formData.append('case_number', this.mycase.vars.case_number)
      formData.append('type_name', this.type)
      this.dropFiles.forEach((file, i) => {
        formData.append(`files${i}`, file)
      })
      axios.post('/upload_multi.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: this.progressEvent
      }).then(res => {
        this.dropFiles = []
        if (res.data.status === 'success') {
          this.status = 'success'
          let files = res.data.files.filter(e => e.status === 'success').map(e => {
            e.created = moment().format()
            return e
          })
          res.data.files.filter(e => e.status === 'fail').map(e => {
            this.$buefy.toast.open({
              message: this.$root.term(e.reason),
              type: 'is-danger'
            })
          })
          if (files.length) {
            this.$emit('file-multiple-status', {
              type: this.type,
              success: true,
              files: files
            })
          }
        } else {
          this.$buefy.toast.open({
            message: `Error: ${res.data.message}`,
            type: 'is-danger'
          })
        }
      }).catch(err => {
        this.status = 'fail'
        this.$emit('file-status', {
          type: this.type,
          success: false
        })
        this.$buefy.toast.open({
          message: `Error: ${err.message}`,
          type: 'is-danger'
        })
      })
    },
    progressEvent (progressEvent) {
      this.uploadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    }
  }
}
</script>
